export default {
  label: {
    commandUrl: 'Url to send commands',
    botKey: 'Bot Key',
  },
  button: {
    save: 'Save information',
  },
  message: {
    success: 'Contract saved successfully',
    error: 'Error saving contract information',
  },
};
